import React, { useEffect } from "react";
import { MainCard } from "../components/Card/Cards";
import Table from "../components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { getdriverList } from "../store/Slices/driverSlice";
import { hidePageLoader } from "../utils/javascript";

export default function ApplicationForms() {
  const dispatch = useDispatch();
  const drivers = useSelector(state=> state?.driver?.list)
  let columns = [
    {
      field: "details.name",
      header: "Name",
    },
    {
      field: "email",
      header: "Email",
    },
    {
      field: "updatedAt",
      header: "Application Date",
      body: (col)=> col?.updatedAt.split('T')[0]
    },
    {
      field: "",
      header: "Action",
    },
  ]
  useEffect(()=>{
    dispatch(getdriverList({hidePageLoader}))
  },[dispatch])
  return (
    <div className="p-3">
      <h3 className="text-center">Driver Applications</h3>
      <MainCard>
        <Table columns={columns} data={drivers}/>
      </MainCard>
    </div>
  );
}
